import { DatabaseWrapper } from '../../../shared/databases/database.wrapper';
import { Database } from '../../../shared/databases/database';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { RepConnWrapper } from '../../repconn/repconn.wrapper';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { Attribute } from 'src/app/shared/models/domain/attribute';

export class IcebergWrapper extends DatabaseWrapper {
    repConnGridTitleNm = 'databaseNm';

    constructor(database: Database) {
        super(database);

        this.dbTyp_Id = DatabaseEnum.iceberg.ID;
        this.name = DatabaseEnum.iceberg.NAME;
        this.code = DatabaseEnum.iceberg.CODE;
        this.equivalentTag = DatabaseEnum.iceberg.EQUIVALENT_TAG;
        this.showDataDescription = false;
        this.hideDatabaseNmDbColumn = true;
        this.conn_DbsTabName = 'Namespace';
	
        //data object tabs
		this.showDataObjectPropertiesTab = true;
		this.showDDLOption = true;
		this.showViewDataTabOption = true;
		this.isShowObjProperties = true;
        this.hideSchemaNmColumn = true; 
        
        this.showSettingsTab = true;
        this.showHdfsSettingsTab = true;
        this.showKerberosSettingsTab = true;
        this.showYARNSettingsTab = true;
    }

        getAttributeColumns(objectWrapper: ObjectWrapper,
            attributes: Array<Attribute> = new Array<Attribute>(), component: any = null,hideRowSelection:boolean=true): Array<any> {
            return [
                this.attributeTabulator.getCheckBoxColumn(objectWrapper,hideRowSelection),
                this.attributeTabulator.getSrt_Order(),
                this.attributeTabulator.getAttr_Id(),
                this.attributeTabulator.getAttrNm(objectWrapper,component),
                this.attributeTabulator.getAttrDTyp_Id(objectWrapper, attributes, component),
                this.attributeTabulator.getAttrPrec(objectWrapper),
                this.attributeTabulator.getAttrScale(objectWrapper),
                this.attributeTabulator.getAttrPiiIdentifierFlag(objectWrapper, true),
                this.attributeTabulator.getNotNullFlag(objectWrapper),
                this.attributeTabulator.getAttrKeyTyp_Id(objectWrapper),
                this.attributeTabulator.getOrderBy(objectWrapper, component),
                this.attributeTabulator.getDescription(objectWrapper),
            ]
        }
        
    validateRepConn(repConnWrapper: RepConnWrapper): void {
        if (repConnWrapper.repConn.conn.sparkMode == 'Standalone') {
            if (repConnWrapper.repConn.conn.host == "") {
                repConnWrapper.inValid_Cds.push('NO_HOST');
            }
            if (repConnWrapper.repConn.conn.port == "") {
                repConnWrapper.inValid_Cds.push('NO_PORT');
            }
        }
        	if (repConnWrapper.repConn.conn.wrhloc == "") {
				repConnWrapper.inValid_Cds.push('NO_SERVICE_NM');
			}
            if (repConnWrapper.repConn.conn.host == "") {
				repConnWrapper.inValid_Cds.push('NO_HOST');
			}
        if (repConnWrapper.repConn.conn.connType == 'Trino') {
			if (repConnWrapper.repConn.conn.ftpUsr == "") {
				repConnWrapper.inValid_Cds.push('NO_USERNAME');
			}
        if (repConnWrapper.repConn.conn.ftpPasswd == "") {
				repConnWrapper.inValid_Cds.push('NO_PASSWORD');
			}    
        if (repConnWrapper.repConn.conn.amazonS3Host == "") {
				repConnWrapper.inValid_Cds.push('NO_MINIO_ENDPOINT');
		    } 
        if (repConnWrapper.repConn.conn.port == "") {
				repConnWrapper.inValid_Cds.push('NO_PORT');
		    }     
        if (repConnWrapper.repConn.conn.accessToken == "") {
				repConnWrapper.inValid_Cds.push('ACCESS_TOKEN');
		    }    
		if (repConnWrapper.repConn.conn.accessTokenSecret == "") {
				repConnWrapper.inValid_Cds.push('REFRESH_TOKEN');
		    }
        if (repConnWrapper.repConn.conn.url == "") {
				repConnWrapper.inValid_Cds.push('NO_METASTORE_URI');
		    }
		}
        if (repConnWrapper.repConn.conn.flagent_Id == -1) {
            repConnWrapper.inValid_Cds.push('ESM00202');
        }
    }

    getConn_DbColumns(repConnWrapper: RepConnWrapper, component: any): Array<any> {
		return [
			this.conn_DbsTabultor.getCheckBoxColumn(repConnWrapper),
			this.conn_DbsTabultor.getName(repConnWrapper),
			this.conn_DbsTabultor.getDatabaseNm(repConnWrapper, component)
		]
	}
}
